export const isInputHasLocale = (locale) => {
    return locale ? true : false;
};

export const addClassError = (errors, name, locale) => {
    if (!isInputHasLocale(locale)) {
        return errors?.[name] ? "input-error" : "";
    }

    return errors?.[name]?.[locale] ? "input-error" : "";
};

export const inputRegister = (register, name, locale, rules) => {
    return register(`${name}${isInputHasLocale(locale) ? `.${locale}` : ""}`, {
        ...rules,
    });
};

export const setNamewithLocale = (name, locale) => {
    return `${name}${isInputHasLocale(locale) ? `.${locale}` : ""}`;
};

export const getToday = () => {
    let today = new Date();
    let dd = String(today.getDate());
    let mm = String(today.getMonth() + 1); //January is 0!
    let yyyy = today.getFullYear();

    today = `${yyyy}-${mm}-${dd}`;
    return today;
};
